import type { Edge } from '@xyflow/react'
import { useCallback } from 'react'

import type { useAgencyFlow } from './agency-flow.hook'
import type { useAgencyFlowCanvasDialogs } from './use-agency-flow-canvas-dialogs.hook'

interface UseEdgeHandlersParams {
  agencyFlow: ReturnType<typeof useAgencyFlow>
  dialogs: ReturnType<typeof useAgencyFlowCanvasDialogs>
  isDrawerOpen: boolean
}

export const useAgencyFlowEdgeHandlers = ({
  agencyFlow,
  dialogs,
  isDrawerOpen,
}: UseEdgeHandlersParams) => {
  const handleEdgeClick = useCallback(
    (event: React.MouseEvent, edge: Edge): void => {
      agencyFlow.onEdgeClick(edge.id)
      dialogs.openEdgePopover(
        edge.id,
        agencyFlow.edgeList.find((e) => e.id === edge.id)?.label ?? '',
        event.clientX,
        event.clientY
      )
    },
    [agencyFlow, dialogs]
  )

  const handlePaneClick = useCallback((): void => {
    if (isDrawerOpen) {
      return
    }
    agencyFlow.clearSelection()
    dialogs.closeEdgePopover()
  }, [agencyFlow, dialogs, isDrawerOpen])

  return { handleEdgeClick, handlePaneClick }
}
